/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Tooltip, Typography } from '@mui/material'
import { Notification } from 'iconsax-react'
import React, { useEffect } from 'react'
import { useGetNotificationSubscribe } from '../../../hook/notifications'
import { useAppId } from '../../../hook/useAppId'
import NotificationDetails from '../../../Pages/Notifications/NotificationDetails'
import { useSessionContex } from '../../../SessionContex'

const NotificationIconButton = () => {
  const appId = useAppId()

  const { data: notificationLists, refetch } = useGetNotificationSubscribe({ app_id: appId })
  const { reCall, setReCall } = useSessionContex()
  const [open, setOpen] = React.useState<boolean>(false)

  useEffect(() => {
    if (appId) {
      refetch()
    }
  }, [appId, refetch])

  useEffect(() => {
    if (reCall) {
      refetch().finally(() => setReCall(false))
    }
  }, [reCall, refetch, setReCall])

  useEffect(() => {
    console.log('notificationLists', notificationLists)
  }, [notificationLists])

  return (
    <React.Fragment>
      <Tooltip
        disableInteractive
        slotProps={{
          tooltip: {
            sx: {
              bgcolor: '#707e8c'
            }
          }
        }}
        title={<Typography>Notifications</Typography>}
      >
        <Button className={`reload-btn me-2`} onClick={() => setOpen(true)} data-testid='testid_group_btn'>
          <Notification color='#636363' />
        </Button>
      </Tooltip>
      <NotificationDetails open={open} setOpen={setOpen} />
    </React.Fragment>
  )
}

export default NotificationIconButton
